const routes = [
  {
    path: ["/GR_landing_page_poc", "/home"],
    exact: true,
    component: "Home",
  },
];

export default routes;
